import * as React from 'react'

import { sanitizeListRestProps, TopToolbar, useTranslate } from 'react-admin'

import tracker from '../../utils/tracker'
import { ExportPaymentActionButton } from './exportPaymentActionButton'

export const PaymentActions = (props) => {
  const translate = useTranslate()
  const {
    className,
    basePath,
    hasShow,
    hasEdit,
    hasList,
    linkDataCreditLines,
    ...rest
  } = props

  let exportOptions = []

  if (props.resource === 'payments') {
    exportOptions = [
      {
        id: ['payments', 'collections', 'entries'],
        name: translate('resources.payments.actions.export.all'),
      },
      {
        id: ['payments', 'entries'],
        name: translate('resources.payments.actions.export.payments'),
      },
    ]
  }
  if (props.resource === 'collections') {
    exportOptions = [
      {
        id: ['payments', 'collections', 'entries'],
        name: translate('resources.collections.actions.export.all'),
      },
      {
        id: ['collections', 'entries'],
        name: translate('resources.collections.actions.export.collections'),
      },
    ]
  }

  const handleExport = (modes) => {
    if (props.resource === 'payments')
      tracker.event({
        action: `payments_export_clicked`,
        category: 'export',
        label: 'optionSelected',
        value: modes?.includes('collections')
          ? 'allTransactions'
          : 'justPayments',
      })
    if (props.resource === 'collections')
      tracker.event({
        action: `collections_export_clicked`,
        category: 'export',
        label: 'optionSelected',
        value: modes?.includes('payments')
          ? 'allTransactions'
          : 'justCollections',
      })
  }

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {props.showExport && (
        <ExportPaymentActionButton
          basePath={basePath}
          label="resources.payments.actions.export.name"
          fields={exportOptions}
          onExport={handleExport}
        />
      )}
    </TopToolbar>
  )
}
